import { EntityTypes } from 'constants/entities';
import { ITextDAO } from './text';

export interface IBaseEntity {
  id: number;
  offlineId?: number;
  type?: EntityTypes | string | number;
  status?: GenericStatus | number;
  created?: IUserDate;
  modified?: IUserDate;
  loading?: LoadingState;
  saving?: SavingState;
  error?: unknown;
}

export enum LoadingState {
  'ERROR' = -1,
  'DEFAULT' = 0,
  'LOADING' = 1,
  'LOADED' = 2,
}

export enum SavingState {
  'ERROR' = -1,
  'SAVING' = 0,
  'SAVED' = 1,
}

export interface IUserDate {
  userId: number;
  date: string;
}

export enum GenericStatus {
  DELETED = -1,
  NEW = 0,
}

export interface INode extends IBaseEntity {
  x: number;
  y: number;
  entityType?: EntityTypes;
  entityId?: number;
}

export interface IPosition extends IBaseEntity {
  x: number;
  y: number;
  z: number;
  entityType?: EntityTypes;
  entityId?: number;
}

export function positionToArray(position: IPosition): [number, number, number] {
  return position ? [position.x, position.y, position.z] : null;
}

export interface IRotation extends IBaseEntity {
  x: number;
  y: number;
  z: number;
  w: number;
  entityType?: EntityTypes;
  entityId?: number;
}

export interface IPortraitVariant extends IBaseEntity {
  positionId: number;
  rotationId: number;
  textId: number;
  entityType?: EntityTypes;
  entityId?: number;
}

export interface IPortraitVariantDAO extends IBaseEntity {
  position: IPosition;
  rotation: IRotation;
  text: ITextDAO;
}
